import clsx from 'clsx';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'white';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}

export function Button({ variant = 'primary', size = 'md', className, children, ...props }: ButtonProps) {
  return (
    <button
      className={clsx(
        'font-medium rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2',
        {
          primary: 'bg-coastal-600 text-white hover:bg-coastal-700 focus:ring-coastal-500',
          secondary: 'bg-gold-100 text-coastal-800 hover:bg-gold-200 focus:ring-gold-400',
          outline: 'border-2 border-coastal-600 text-coastal-600 hover:bg-coastal-50 focus:ring-coastal-500',
          white: 'bg-white text-coastal-800 hover:bg-gray-100 focus:ring-white',
        }[variant],
        { sm: 'px-4 py-2 text-sm', md: 'px-6 py-3 text-base', lg: 'px-8 py-4 text-lg' }[size],
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
